module.exports = __webpack_public_path__ + "assets/img/24_420_big.cde611e3.jpg";